// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"ad4b3d06","278":"ce87d444","405":"c01986e2","488":"f2f58a21","596":"a079426d","696":"83d2ed55","748":"34af6335","841":"cf39a1b5","885":"6f353723"}[chunkId] + ".chunk.js";
};